import queryString from 'query-string'
import MobileDetect from 'mobile-detect'
import Ajax from 'superagent'

export function setUrlFragment(browserHistory, fragment) {
  const loc = browserHistory.getCurrentLocation() 
  browserHistory.replace(`${loc.pathname}?${queryString.stringify(loc.query)}#${fragment}`)
}

export function getUrlFragment(browserHistory): string {
  return browserHistory.getCurrentLocation().hash
}

export function replaceQuery(history: Object, query: Object, changes: ?Object) {
  const loc = history.getCurrentLocation() 
  history.replace(
    changes 
    ? `${loc.pathname}?${queryString.stringify({ ...query, ...changes })}${loc.hash}`
    : `${loc.pathname}?${queryString.stringify(query)}${loc.hash}`
  )
}


export function getGeolocationParameters({nextAddress, currentAddress, currentCity}) {
  if (nextAddress && nextAddress != currentAddress) {
    return encodeURIComponent(`${nextAddress}, ${currentCity}`)
  }
  else {
    return null
  } 
}

export function fetchGeolocation(x) {
  return new Promise((resolve, reject) => {
    if (x) {
      console.log(`gonna look up: ${x}`)
      Ajax
        .get(`https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCqgRbFVinfn9W8m0O2zxxc_haZl895tN8&address=${x}`)
        .end((e, r) => {
          if (r.body.results.length > 0) {
            const geolocation = r.body.results[0]
            resolve(geolocation)
          } 
          else {
            console.log(x)
            reject(`error fetching directions ${r.body.status}`)
          }
        })
    }
    else reject('Received empty parameter')
  })
}
/**
 *
 */

const md = new MobileDetect(window.navigator.userAgent)
const mobile = (
  md.mobile() && (
    document.documentElement.clientWidth < 1024 
    || document.documentElement.clientHeight < 1024)
)

export function isMobile() {
  return mobile
}

// #TODO don't hardcode the google api key!
// #TODO do this from the server
export const getAddress = (latitude, longitude) => (
  fetch(`/getAddress?latitude=${latitude}&longitude=${longitude}`)
    .then(response => response.json())
    .then(things => things)
) 



// WEBPACK FOOTER //
// ./src/app/AppTools.js